import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Client } from "features/mst_client/types/client";
import { useNavigate } from "react-router";
import prefecture from "util/prefecture";
import { TableButtonSxProps, TableContainerSXProps, TableRowSxProps } from "./styles";

interface ClientTableContainerProps {
  clients: Client[];
  selectClient: (client: Client) => void;
  totalRecord: number;
}

/**
 * ClientTableContainer component renders a table of clients with pagination and modal functionality.
 * @param {ClientTableContainerProps} props - The props for the ClientTableContainer component.
 * @param {Client[]} props.clients - The list of clients to display in the table.
 * @param {(client: Client) => void} props.selectClient - The function to call when a client is selected.
 * @param {number} props.totalRecord - The total number of clients.
 * @returns The rendered component.  
 */
function ClientTableContainer({ clients, selectClient, totalRecord }: ClientTableContainerProps) {
  const navigate = useNavigate();

  const TableColumns = ["得意先ID", "得意先名", "都道府県", /* "発送先", */ "詳細"];

  const handleNavigateClientDetail = (client: Client) => {
    navigate(`/mst-client/${client.id}/mst-shipping-dest?client_cd=${client.client_cd}`);
  };

  return (
    <Box
      p={{ xs: 2, md: 2.5, lg: 5 }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      bgcolor="var(--offwhite-100)"
      height="100%"
    >
      <Box sx={{ width: { xs: "100%", lg: 1254 } }} display="flex" justifyContent="flex-end">
        <Typography fontWeight="regular" fontSize={{ xs: 16, md: 18, lg: 20 }} mr="20px" color="black">
          件数【{totalRecord}件】
        </Typography>
      </Box>
      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <TableContainer sx={TableContainerSXProps}>
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ "& .MuiTableCell-head": { minWidth: "50px" } }}>
                {TableColumns.map((column) => (
                  <TableCell align="center" sx={TableRowSxProps} key={column}>
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {clients.map((client, index) => (
                <TableRow
                  key={client.id}
                  sx={index % 2 ? { bgcolor: "var(--offwhite-300)" } : { bgcolor: "var(--white)" }}
                >
                  <TableCell align="center" sx={{ fontSize: { xs: 16, md: 18, lg: 20 }, width: "200px" }}>
                    {client.client_cd}
                  </TableCell>
                  <TableCell sx={{ fontSize: { xs: 16, md: 18, lg: 20 }, width: "414px" }}>
                    {client.mst_client_client_name || client.store_name}
                  </TableCell>
                  <TableCell align="left" sx={{ fontSize: { xs: 16, md: 18, lg: 20 }, width: "208px" }}>
                    {prefecture.find((pref) => pref.code === client.pref_cd)?.name}
                  </TableCell>
                  {/* <TableCell align="center" sx={{ width: "208px" }}>
                    <Button
                      onClick={() => handleNavigateClientDetail(client)}
                      sx={TableButtonSxProps}
                      variant="outlined"
                    >
                      発送先
                    </Button>
                  </TableCell> */}
                  <TableCell align="center" sx={{ width: "208px" }}>
                    <Button
                      sx={TableButtonSxProps}
                      variant="outlined"
                      onClick={() => selectClient(client)}
                    >
                      詳細
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default ClientTableContainer;
